// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2P7-n","title":"Zu00X","button":"_3oh4K","bannerTwo":"_1qAvT","right":"WKQ_E"};